import React from 'react';

const SvgIconExtension = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 9" {...props}>
    <path d="M6.316 8.196h.092C7.288 8.196 8 7.483 8 6.603V3.881c0-.437-.18-.854-.495-1.155L5.097.438a1.592 1.592 0 00-2.194 0L.495 2.726A1.598 1.598 0 000 3.881v2.722c0 .88.713 1.593 1.592 1.593h.093c.842 0 1.525-.683 1.525-1.526v-.723c0-.443.36-.802.802-.802a.796.796 0 01.796.802l-.006.723a1.513 1.513 0 001.501 1.526h.013z" />
  </svg>
);

export default SvgIconExtension;
